import { defineMessages } from 'react-intl';

export default defineMessages({
  outOfStock: {
    id: 'SizeSelection.outOfStock',
    defaultMessage: 'Out of Stock',
  },
});
